import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import SplitText from 'gsap/SplitText';
import { onWidthResize, offWidthResize } from '../utils/resize.js';
gsap.registerPlugin(ScrollTrigger, SplitText);

export default class StockistsHero {
    constructor(container) {
        this.container = container;
        this.title = container.querySelector('.stockists-hero__title');
        this.media = container.querySelector('.stockists-hero__media');
        this.mediaImg = this.media?.querySelector('img');

        this.init();
    }

    init = () => {
        this.initMediaAnimation();
        this.initTitleAnimation();
    }

    initMediaAnimation = () => {
        if (!this.media) return;

        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const fromClip = isMobile ? 'inset(0% 0% 100% 0%)' : 'inset(0% 0% 0% 100%)';

        gsap.fromTo(
            this.media,
            { clipPath: fromClip },
            {
                clipPath: 'inset(0% 0% 0% 0%)',
                duration: 1.2,
                delay: .7,
                ease: 'power3.inOut',
                scrollTrigger: { trigger: this.container },
            }
        );

        if (this.mediaImg) {
            gsap.fromTo(
                this.mediaImg,
                { scale: 1.2 },
                {
                    scale: 1,
                    duration: 1.2,
                    delay: .7,
                    ease: 'power3.inOut',
                    scrollTrigger: { trigger: this.container },
                }
            );
        }
    }

    initTitleAnimation = () => {
        if (!this.title) return;

        this.titleSplit = new SplitText(this.title, { type: 'lines,words', linesClass: 'lineParent' });

        gsap.fromTo(
            this.titleSplit.words,
            { yPercent: 100 },
            {
                yPercent: 0,
                duration: 0.6,
                delay: 0.6,
                stagger: { each: 0.07, ease: 'power2.out', from: 'start' },
                ease: 'power3.out',
                scrollTrigger: { trigger: this.container },
                onComplete: () => {
                    onWidthResize(this.onTitleResize);
                },
            }
        );
    }

    onTitleResize = () => {
        this.titleSplit?.revert();
        offWidthResize(this.onTitleResize);
    }
}
